import React from 'react'

import { Summary, SummaryCounters } from '../../../components/Summary/Summary'
import { formatCurrency } from '../../../formatters'
import { Rfq } from '../models'

const buildInitialSummaryCounters = () => ({
  total: { value: 0, title: 'Total' },
  open: { value: 0, title: 'Open' },
  closed: { value: 0, title: 'Closed' },
  cancelled: { value: 0, title: 'Cancelled' },
  adiFee: { value: 0, title: 'ADI Fees ($)' },
})

const calculateSummary = (rfqs: Rfq[]): SummaryCounters => {
  const counters = buildInitialSummaryCounters()

  const summary = rfqs.reduce((summary, rfq: Rfq) => {
    summary[rfq.status].value += rfq.principal
    summary.total.value += rfq.principal
    summary.adiFee.value += rfq.adiFee || 0

    return summary
  }, counters)

  return formatSummaryValues(summary)
}

const formatSummaryValues = (summary: SummaryCounters) => {
  Object.keys(summary).forEach((summaryCounter) => {
    if (summaryCounter === 'adiFee') {
      summary.adiFee.value = formatCurrency({ value: summary.adiFee.value })
      return
    }

    return (summary[summaryCounter].value = formatCurrency({
      value: summary[summaryCounter].value,
      notation: 'compact',
      maximumPrecision: 3,
    }))
  })

  return summary
}

export const RfqsSummary = ({ rfqs }: { rfqs: Rfq[] }) => (
  <Summary items={rfqs} calculateSummaryItemsFunction={calculateSummary} />
)
